import { BandRenderer } from './band-renderer';
import { NgModule } from '@angular/core';
import { TrendsSubjectColorResolver } from './trends-subject-color-resolver';
import { OsrLegendDataService } from './osr-legend-data.service';
import { TrendsChartDataBuilder } from './trends-chart-data-builder';
import { BoxplotChartDataBuilder } from './boxplot-chart-data-builder';

@NgModule({
    providers: [
        TrendsSubjectColorResolver,
        OsrLegendDataService,
        TrendsChartDataBuilder,
        BoxplotChartDataBuilder,
        BandRenderer
    ],
})
export class ChartsModule { }